/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CrmAddTestConversationInboundMessageBodyParams } from '../models/CrmAddTestConversationInboundMessageBodyParams';
import type { CrmAddTestConversationInboundMessageResponse } from '../models/CrmAddTestConversationInboundMessageResponse';
import type { CrmCreateTestConversationBodyParams } from '../models/CrmCreateTestConversationBodyParams';
import type { CrmCreateTestConversationResponse } from '../models/CrmCreateTestConversationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmTestConversationsService {
    /**
     * @param requestBody
     * @returns CrmCreateTestConversationResponse Ok
     * @throws ApiError
     */
    public static createTestConversation(
        requestBody: CrmCreateTestConversationBodyParams,
    ): CancelablePromise<CrmCreateTestConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/test-conversations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param conversationId
     * @param requestBody
     * @returns CrmAddTestConversationInboundMessageResponse Ok
     * @throws ApiError
     */
    public static addInboundMessage(
        conversationId: number,
        requestBody: CrmAddTestConversationInboundMessageBodyParams,
    ): CancelablePromise<CrmAddTestConversationInboundMessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/test-conversations/{conversationId}/messages/inbound',
            path: {
                'conversationId': conversationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
